import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import Uuid from '../../../../../support/Uuid';
import NominaPercepcionForm from './NominaPercepcionForm';
import { FormControl } from '../../../../../facturotopia';
import NominaPercepcionesList from './NominaPercepcionesList';
import NominaPercepcionesCalculator from '../../../support/nomina/NominaPercepcionesCalculator';
import NominaPercepcionesJubilacionPensionRetiroForm from './NominaPercepcionesJubilacionPensionRetiroForm';
import NominaPercepcionesSeparacionIndemnizacionForm from './NominaPercepcionesSeparacionIndemnizacionForm';

class NominaPercepcionesManager extends Component {
  state = {};

  get rules() {
    return {
      TotalSueldos: ['decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TotalSeparacionIndemnizacion: ['decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TotalJubilacionPensionRetiro: ['decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TotalGravado: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TotalExento: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],

      SeparacionIndemnizacion: this.isSeparacionIndemnizacionRequired() ? this.separacionIndemnizacionRules : [],
      JubilacionPensionRetiro: this.isJubilacionPensionRetiroRequired() ? this.jubilacionPensionRetiroRules : [],
    };
  }

  get separacionIndemnizacionRules() {
    return {
      TotalPagado: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      NumAñosServicio: ['required', 'integer', 'min:0', 'max:99'],
      UltimoSueldoMensOrd: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      IngresoAcumulable: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      IngresoNoAcumulable: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
    };
  }

  get jubilacionPensionRetiroRules() {
    return {
      TotalUnaExhibicion: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      TotalParcialidad: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      MontoDiario: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      IngresoAcumulable: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      IngresoNoAcumulable: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
    };
  }

  handleOnChange = (value) => {};

  handleOnAdd = (data) => {
    const { Percepciones = {} } = this.props.data;
    const { Percepcion = [] } = Percepciones;

    const newData = Percepcion.concat([
      {
        id: Uuid.v4(),
        ...data,
      },
    ]);

    this.handleOnListChange(newData);
  };

  handleOnEdit = (item) => {
    this.setState(
      {
        data: { ...item },
      },
      () => {
        this.setState({
          data: undefined,
        });
      }
    );
  };

  handleOnChangeJubilacionPensionRetiro = (event) => {
    const { Percepciones = {} } = this.props.data;
    const { Percepcion = [] } = Percepciones;

    this.handleOnListChange(Percepcion, {
      JubilacionPensionRetiro: event.data,
    });
  };

  handleOnChangeSeparacionIndemnizacion = (event) => {
    const { Percepciones = {} } = this.props.data;
    const { Percepcion = [] } = Percepciones;

    this.handleOnListChange(Percepcion, {
      SeparacionIndemnizacion: event.data,
    });
  };

  handleOnListChange = (data, additional = {}) => {
    const { Percepciones = {} } = this.props.data;

    const calc = NominaPercepcionesCalculator.make(data).get();

    this.props.onChange({
      ...this.props.data,
      Percepciones: {
        ...Percepciones,
        TotalSueldos: calc.totalSueldos,
        TotalSeparacionIndemnizacion: calc.totalSeparacionIndemnizacion,
        TotalJubilacionPensionRetiro: calc.totalJubilacionPensionRetiro,
        TotalGravado: calc.totalGravado,
        TotalExento: calc.totalExento,
        Percepcion: data,
        ...additional,
      },
    });
  };

  isJubilacionPensionRetiroRequired = () => {
    const { Percepciones = {} } = this.props.data;
    const { Percepcion = [] } = Percepciones;

    const haystack = [
      '039', // Jubilaciones, pensiones o haberes de retiro en una exhibición
      '044', // Jubilaciones, pensiones o haberes de retiro en parcialidades
    ];

    for (const item of Percepcion) {
      if (haystack.indexOf(item.TipoPercepcion) !== -1) {
        return true;
      }
    }

    return false;
  };

  isSeparacionIndemnizacionRequired = () => {
    const { Percepciones = {} } = this.props.data;
    const { Percepcion = [] } = Percepciones;

    const haystack = [
      '022', // Prima por Antigüedad,
      '023', // Pagos por separación
      '025', // Indemnizaciones
    ];

    for (const item of Percepcion) {
      if (haystack.indexOf(item.TipoPercepcion) !== -1) {
        return true;
      }
    }

    return false;
  };

  render() {
    const rules = this.rules;
    const { data } = this.state;
    const { Percepciones = {} } = this.props.data;

    const isJubilacionPensionRetiroRequired = this.isJubilacionPensionRetiroRequired();
    const isSeparacionIndemnizacionRequired = this.isSeparacionIndemnizacionRequired();

    return (
      <>
        <div className="pb-4">
          <div className="section pt-2">
            <div data-testid="nomina-percepcion-form">
              <NominaPercepcionForm
                data={data}
                onAdd={this.handleOnAdd}
              />
            </div>

            <div
              className="pt-2"
              data-testid="nomina-percepcion-list"
            >
              <NominaPercepcionesList
                data={Percepciones.Percepcion}
                onEdit={this.handleOnEdit}
                onChange={this.handleOnListChange}
              />
            </div>

            {!!isJubilacionPensionRetiroRequired && (
              <div className="pb-3">
                <fieldset>
                  <legend>Jubilación Pensión Retiro</legend>
                  <NominaPercepcionesJubilacionPensionRetiroForm
                    data={Percepciones.JubilacionPensionRetiro}
                    rules={this.rules.JubilacionPensionRetiro}
                    onChange={this.handleOnChangeJubilacionPensionRetiro}
                  />
                </fieldset>
              </div>
            )}

            {!!isSeparacionIndemnizacionRequired && (
              <div className="pb-3">
                <fieldset>
                  <legend>Separación Indemnización</legend>

                  <NominaPercepcionesSeparacionIndemnizacionForm
                    data={Percepciones.SeparacionIndemnizacion}
                    rules={this.rules.SeparacionIndemnizacion}
                    onChange={this.handleOnChangeSeparacionIndemnizacion}
                  />
                </fieldset>
              </div>
            )}

            <div>
              <strong className="text-muted">Resumen de percepciones</strong>
            </div>

            <Row>
              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Total Sueldos"
                  name="TotalSueldos"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.TotalSueldos}
                  value={Percepciones.TotalSueldos}
                  onChange={this.handleOnChange}
                />
              </Col>

              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Total Separación Indemnización"
                  name="TotalSeparacionIndemnizacion"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.TotalSeparacionIndemnizacion}
                  value={Percepciones.TotalSeparacionIndemnizacion}
                  onChange={this.handleOnChange}
                />
              </Col>

              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Total Jubilación Pensión Retiro"
                  name="TotalJubilacionPensionRetiro"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.TotalJubilacionPensionRetiro}
                  value={Percepciones.TotalJubilacionPensionRetiro}
                  onChange={this.handleOnChange}
                />
              </Col>

              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Total Gravado"
                  name="TotalGravado"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.TotalGravado}
                  value={Percepciones.TotalGravado}
                  onChange={this.handleOnChange}
                />
              </Col>

              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Total Exento"
                  name="TotalExento"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.TotalExento}
                  value={Percepciones.TotalExento}
                  onChange={this.handleOnChange}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="text-muted">Los totales serán calculados automáticamente</p>
              </Col>
            </Row>
          </div>
        </div>
      </>
    );
  }
}

export default NominaPercepcionesManager;
